export class AwsEbsVolumeRestoreResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEbsVolumeRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
